import { render, staticRenderFns } from "./BusDeclaration.vue?vue&type=template&id=7a9aeba6&scoped=true&"
import script from "./BusDeclaration.vue?vue&type=script&lang=js&"
export * from "./BusDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./BusDeclaration.vue?vue&type=style&index=0&id=7a9aeba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9aeba6",
  null
  
)

export default component.exports